import { useEffect, useState } from "react";
import Button from "../../Components/Button";
import Modal from "../../Components/Modal/Modal";
import {
  IMarketmakingConfig,
  IMarketmakingInstruments,
} from "../../Interfaces/marketmaking";
import TextInput from "../../Components/TextInput";
import {
  getDistinctBaseInstrument,
  getMarketmakingConfig,
  setMarketmakingConfig,
} from "../../Requests/marketmaking";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import { getStepInstruments } from "../../Requests/stepRequests";
import StaticDropdown from "../../Components/Dropdown/StaticDropdown";

const Config = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [config, setConfig] = useState({
    instruments: [] as IMarketmakingInstruments[],
  } as IMarketmakingConfig);
  const [instruments, setInstruments] = useState([] as DropdownItem[]);

  function fetchInstruments() {
    getStepInstruments()
      .then((resp) => {
        setInstruments(resp);
      })
      .catch(packetErrorHandler);
  }

  useEffect(() => {
    fetchInstruments();

    setLoading(true);
    getDistinctBaseInstrument()
      .then((insResp) => {
        getMarketmakingConfig()
          .then((resp) => {
            const result = resp;
            insResp.forEach((ins) => {
              if (!resp.instruments.find((f) => f.baseId === ins.id))
                result.instruments.push({
                  baseId: ins.id as any,
                  baseName: ins.name,
                } as IMarketmakingInstruments);
            });
            setConfig(result);
          })
          .catch(packetErrorHandler)
          .finally(() => setLoading(false));
      })
      .catch(packetErrorHandler);
  }, []);

  const setConfigHandler = () => {
    setLoading(true);
    setMarketmakingConfig(config)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setIsOpen(false);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const instrumentChangeHandler = (insId: number, name: string, value: any) => {
    const targetIndex = config.instruments.findIndex((f) => f.baseId === insId);
    if (targetIndex === -1) return;
    const clone = [...config.instruments];
    clone.splice(targetIndex, 1, {
      ...config.instruments[targetIndex],
      [name]: value,
    });
    setConfig({
      ...config,
      instruments: [...clone],
    });
  };

  const modalUI = (
    <div className="w-full flex flex-col justify-start items-center gap-5 ">
      <div className="w-[200px] ml-auto">
        <TextInput
          label="نرخ بهره"
          name="riskFreeRate"
          onChange={changeHandler}
          value={config?.riskFreeRate?.toString() || ""}
          kind="percent"
          extraLabel
        />
      </div>
      <div className="w-full grid grid-cols-8 gap-x-5 gap-y-3">
        <div>نماد پایه</div>
        <div>آپشن معیار اول</div>
        <div>آپشن معیار دوم</div>
        <div>IV-inf</div>
        <div>روز تا سررسید</div>
        <div>ضریب ATM</div>
        <div>ضریب ITM</div>
        <div>ضریب OTM</div>
        {config && config.instruments && config.instruments.length ? (
          config.instruments.map((ins) => (
            <>
              <div>{ins.baseName}</div>
              <StaticDropdown
                dropdown={{
                  name: "refOption1",
                  placeholder: "آپشن معیار اول",
                }}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
                options={instruments}
                value={ins.refOption1}
              />
              <StaticDropdown
                dropdown={{
                  name: "refOption2",
                  placeholder: "آپشن معیار دوم",
                }}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
                options={instruments}
                value={ins.refOption2}
              />
              <TextInput
                label="IV-inf"
                name="ivInf"
                value={ins.ivInf}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
              />
              <TextInput
                label="روز تا سررسید"
                name="remainingDays"
                value={ins.remainingDays?.toString()}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
              />
              <TextInput
                label="ضریب ATM"
                name="aTMFactor"
                value={ins.aTMFactor}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
              />
              <TextInput
                label="ضریب ITM"
                name="iTMFactor"
                value={ins.iTMFactor}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
              />
              <TextInput
                label="ضریب OTM"
                name="oTMFactor"
                value={ins.oTMFactor}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseId, ...props)
                }
              />
            </>
          ))
        ) : (
          <></>
        )}
      </div>
      <div className="w-[100px] mr-auto">
        <Button onClick={setConfigHandler} text="ثبت" variant="contained" />
      </div>
    </div>
  );

  return (
    <>
      {isOpen ? <Modal title="تنظیمات" UI={modalUI} onClose={() => setIsOpen(false)} /> : <></>}
      {isLoading ? <FullScreenLoading /> : <></>}
      <Button
        onClick={() => setIsOpen(true)}
        text="تنظیمات"
        variant="outlined"
      />
    </>
  );
};

export default Config;
